import React, { useEffect, useState } from "react"
import { Modal, ModalBody, ModalHeader } from "reactstrap"
import Spinners from "components/Common/Spinner"
import closeIcon from "../../../assets/images/icons/close.svg"
import toast from "react-hot-toast"
import { useSelector } from "react-redux"
import RaiseQueryFrom from "./raiseQueryFrom"
import PhoneVerificationIcon from "../../../assets/images/icons/phone-verification.svg"
import BankDetailIcon from "../../../assets/images/icons/bank-details.svg"
import AdditionalDetailsIcon from "../../../assets/images/icons/additional-details.svg"
import IDVerificationIcon from "../../../assets/images/icons/id-verification.svg"
import SignaturePhoto from "../../../assets/images/icons/signature-and-photo.svg"
import Agreement from "../../../assets/images/icons/agreement.svg"
import AuthorityLetter from "../../../assets/images/icons/authority-letter.svg"
import AuthorisedSignatoryIcon from "../../../assets/images/icons/authorised-signatory-kyc.svg"

const individualSteps = [
  {
    label: "Phone Verification",
    key: "PHONE_VERIFICATION",
    icon: PhoneVerificationIcon,
  },
  {
    label: "ID Verification",
    key: "ID_VERIFICATION",
    icon: IDVerificationIcon,
  },
  {
    label: "Bank Verification",
    key: "BANK_VERIFICATION",
    icon: BankDetailIcon,
  },
  // {
  //   label: "Demat Verification",
  //   key: "DEMAT_DETAILS",
  //   icon: BankDetailIcon,
  // },
  {
    label: "Additional Details",
    key: "ADDITIONAL_DETAILS",
    icon: AdditionalDetailsIcon,
  },
  {
    label: "Photo",
    key: "PHOTO",
    icon: SignaturePhoto,
  },
]

const nonIndividualSteps = [
  {
    label: "Phone Verification",
    key: "PHONE_VERIFICATION",
    icon: PhoneVerificationIcon,
  },
  {
    label: "Proof of Identity",
    key: "PAN_GST",
    icon: IDVerificationIcon,
  },
  {
    label: "Additional Details",
    key: "BUSINESS_ADDITIONAL_DETAILS",
    icon: AdditionalDetailsIcon,
  },
  {
    label: "Bank Verification",
    key: "BANK_VERIFICATION",
    icon: BankDetailIcon,
  },
  // {
  //   label: "Demat Verification",
  //   key: "DEMAT_DETAILS",
  //   icon: BankDetailIcon,
  // },
  {
    label: "Authorised Person",
    key: "AUTHORISED_SIGNATORY",
    icon: AuthorisedSignatoryIcon,
  },
  {
    label: "Photo",
    key: "PHOTO",
    icon: SignaturePhoto,
  },
  {
    label: "Upload Authority Letter",
    key: "AUTHORITY_LETTER",
    icon: AuthorityLetter,
  },
]
function KycRaiseQuery({
  id,
  entityType,
  open,
  setOpen,
  isLoading,
  title = "Raise Query",
  description = "",
  onSubmit,
  onSuccess,
  onClose,
}) {
  const { user, userType } = useSelector((state) => state.user)
  const [steps, setSteps] = useState([])
  const [originalSteps, setOriginalSteps] = useState([])
  const [selectedSteps, setSelectedSteps] = useState([])
  const [formOpen, setFormOpen] = useState(false)

  useEffect(() => {
    if (user) {
      const steps =
        entityType === "COMPANY" ? nonIndividualSteps : individualSteps
      setSteps(steps)
      setOriginalSteps(steps)
    }
  }, [entityType])

  useEffect(() => {
    if (originalSteps.length > 0) {
      const selectedStepKeys = selectedSteps.map((item) => item.key)

      const result = originalSteps.filter(
        (item) => !selectedStepKeys.includes(item.key)
      )
      setSteps(result)
    }
  }, [selectedSteps])

  const handleSubmit = async () => {
    try {
      const { success, message } = await onSubmit({
        id,
        steps: selectedSteps,
        roleType: "WEALTH_PARTNER",
      }).unwrap()
      if (success) {
        onSuccess()
        onClose()
        toast.success(message, { id: "toastMessage" })
      }
    } catch (error) {
      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }
  return (
    <>
      <Modal
        isOpen={open}
        toggle={() => {
          setOpen((prev) => !prev)
        }}
        returnFocusAfterClose={true}
        centered
        className="custom-size"
      >
        <ModalHeader
          toggle={() => {
            setOpen((prev) => !prev)
          }}
        >
          {title}
          <p style={{ fontSize: "14px", fontWeight: "400", marginBottom: 0 }}>
            {description}
          </p>
        </ModalHeader>
        <ModalBody>
          <div className="">
            <div className="d-flex flex-column raise-query-modal-wrapper">
              {selectedSteps.length > 0 && (
                <>
                  {selectedSteps.map((item, index) => (
                    <div
                      className="d-flex align-items-center justify-content-between gap-3 raise-query-modal"
                      key={`selectedSteps_${index}`}
                    >
                      <div>
                        <span
                          style={{
                            fontWeight: "500",
                            marginRight: "5px",
                            fontSize: "15px",
                          }}
                        >
                          {item.label}
                        </span>
                        <div
                          style={{ color: "#a5a5a5", whiteSpace: "pre-wrap" }}
                        >
                          {item.message}
                        </div>
                      </div>
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          setSelectedSteps((prev) =>
                            prev.filter((_, i) => i !== index)
                          )
                        }
                      >
                        <img
                          className="cp"
                          src={closeIcon}
                          alt=""
                          height={"10px"}
                        />
                      </span>
                    </div>
                  ))}
                </>
              )}
            </div>
            <RaiseQueryFrom
              open={formOpen}
              steps={steps}
              setOpen={setFormOpen}
              onClose={() => {
                setFormOpen(false)
              }}
              onSubmit={(item) => {
                setSelectedSteps((prev) => [...prev, item])
                setFormOpen(false)
              }}
            />

            <div
              className="pt-2 mb-0 mt-0 button-wrapper flex-column buttons position-relative z-2"
              style={{
                alignItems: selectedSteps.length <= 0 ? "center" : "start",
              }}
            >
              {selectedSteps.length < originalSteps.length && (
                <>
                  {selectedSteps.length <= 0 && (
                    <div className="text-center">
                      <h5 className="m-0">Select KYC step to proceed</h5>
                      <p className="mt-2">
                        Select a KYC step to raise a query about <br /> the
                        submitted information
                      </p>
                    </div>
                  )}
                  <button
                    type="button"
                    className="btn cancel"
                    style={{
                      color: "#035CA1",
                      borderColor: "#035CA1",
                      minWidth: "160px",
                      padding: "8px 8px",
                      fontSize: "14px",
                      marginBottom: "20px",
                    }}
                    onClick={() => setFormOpen(true)}
                  >
                    {selectedSteps.length <= 0
                      ? "Raise Query"
                      : "Raise More Query"}
                  </button>
                </>
              )}
            </div>
          </div>
          {selectedSteps.length > 0 && (
            <div className="mt-3 pt-3 mb-0 button-wrapper buttons position-relative z-2">
              <button
                onClick={() => onClose()}
                type="button"
                className="cancel"
                disabled={isLoading}
              >
                Cancel
              </button>
              <button
                type="button"
                className="approve btn btn-secondary"
                onClick={handleSubmit}
              >
                {isLoading ? <Spinners /> : "Submit Query"}
              </button>
            </div>
          )}
        </ModalBody>
      </Modal>
    </>
  )
}

export default KycRaiseQuery
